import FlashReportImage from 'modules/components/FlashReport/Image';

export default class Notifications {
  constructor(el) {
    this.el = el;
    document.addEventListener('DOMContentLoaded', this.initialize);
  }

  initialize() {
    const el = this.el || document.querySelector('#js-flash-report');
    if (!el) {
      return;
    }
    new Vue({
      el,
      name: 'FlashReport',
      components: {
        FlashReportImage,
      },
      data() {
        return {
          pt: 0,
          announcements: [],
          width: 0,
        };
      },
      computed: {
        flashText() {
          if (!this.announcements[this.pt]) {
            return '';
          }
          return this.announcements[this.pt].content;
        },
        flashLink() {
          if (!this.announcements[this.pt]) {
            return '';
          }
          return this.announcements[this.pt].link_url;
        },
        flashIconType() {
          if (!this.announcements[this.pt]) {
            return '';
          }
          return this.announcements[this.pt].icon_type;
        },
        flashImagePath() {
          if (!this.announcements[this.pt]) {
            return '';
          }
          return this.announcements[this.pt].icon_url;
        },
      },
      mounted() {
        this.announcements = JSON.parse(this.$el.getAttribute('data-announcements'));
        setTimeout(() => {
          this.setWidth(this.$refs.item);
        }, 1000);
        setTimeout(() => {
          this.animation();
          setInterval(() => {
            if (!document.hidden) {
              this.animation();
            }
          }, 12000);
        }, 3000);
      },
      methods: {
        animation() {
          this.pt += 1;
          if (this.pt >= this.announcements.length) {
            this.pt = 0;
          }
        },
        beforeEnter(elm) {
          elm.style.transform = `translateX(${this.width}px)`;
        },
        enter(elm, done) {
          setTimeout(() => {
            elm.style.transform = '';
            this.setWidth(elm);
            return done();
          }, 100);
        },
        setWidth(elm) {
          this.width = elm.offsetWidth;
        },
        beforeLeave(elm) {
          elm.style.width = `${this.width}px`;
        },
      },
    });
  }
}
